import React from 'react'
import PropTypes from 'prop-types'
import { isMobile, MobileView, BrowserView, TabletView, isTablet } from 'react-device-detect'

import styled from 'styled-components'

import { Layout } from 'core/components/ui'
import Footer from 'core/components/footer'
import { greys } from 'assets/themes/theme-default'
import { initOrejime } from 'core/utils/cookies/config'

import Header from '../header'
import ErrorBoundary from '../../components/errorBoundary'
import ModalDeletInfo from '../modal-delete-info'

const { Content } = Layout

const StyledContent = styled(Content)`
  background: ${greys.light4};
  padding: ${props =>
    isMobile ? `70px ${props.showSider ? '70px' : '20px'} 70px 20px` : '64px 0px 90px 0px'};
  width: 100%;
  padding-top: ${props => props.paddingtop}px;
  & .steps {
    ${isMobile && 'overflow:hidden;'}
  }
`

initOrejime()

const BasicLayout = props => {
  const { children, configuration } = props
  const { campaign } = configuration

  let PanelTheme

  const hydrateString = string => {
    let value = string
    if (value.length) {
      if (value.charAt(0) === '/') value = value.substring(1, value.length)
      value = value.replaceAll('/', '-')
    }
    return value
  }

  return (
    <Layout
      id={hydrateString(children[0].key)}
      type="flex"
      align="stretch"
      style={{ height: '100%' }}
      data-test="component-layout"
    >
      <Header data-test="layout-header" />
      <ErrorBoundary>
        {PanelTheme}
        <TabletView>
          <Layout>
            <StyledContent
              data-test="layout-content"
              //showSider={showSider}
              paddingtop={
                campaign &&
                campaign.theme &&
                campaign.theme.header &&
                campaign.theme.header.header &&
                campaign.theme.header.header.height
              }
            >
              {children}
            </StyledContent>
          </Layout>
        </TabletView>
        {!isTablet && (
          <MobileView>
            <Layout>
              <StyledContent
                data-test="layout-content"
                //showSider={showSider}
                paddingtop={
                  campaign &&
                  campaign.theme &&
                  campaign.theme.header &&
                  campaign.theme.header.header &&
                  campaign.theme.header.header.height
                }
              >
                {children}
              </StyledContent>
            </Layout>
          </MobileView>
        )}
        {!isTablet && (
          <BrowserView>
            <Layout>
              <StyledContent
                data-test="layout-content"
                paddingtop={
                  campaign &&
                  campaign.theme &&
                  campaign.theme.header &&
                  campaign.theme.header.header &&
                  campaign.theme.header.header.height
                }
              >
                {children}
              </StyledContent>
            </Layout>
          </BrowserView>
        )}
      </ErrorBoundary>
      <Footer />
      <ModalDeletInfo />
    </Layout>
  )
}

BasicLayout.propTypes = {
  children: PropTypes.node.isRequired,
  configuration: PropTypes.shape().isRequired
}

export default BasicLayout
